import { render, staticRenderFns } from "./examPoint.vue?vue&type=template&id=0af88c0a"
import script from "./examPoint.vue?vue&type=script&lang=js"
export * from "./examPoint.vue?vue&type=script&lang=js"
import style0 from "./examPoint.vue?vue&type=style&index=0&id=0af88c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports